// @ts-nocheck
import React, { useState, Fragment, useEffect, useCallback } from 'react';
import {
  Row, Col, Card, Input, Label, Button, CardBody, CardHeader,
  Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup,
  CardFooter, Badge, Table, UncontrolledTooltip, Spinner
} from 'reactstrap';
import { AesEncrypt, keyPromise } from '../../Service/crypto';
import api from '../../api';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Edit, Trash2, Copy, Maximize, FileText, Plus, UploadCloud, File, List, Activity, Clock, Code, Send } from 'react-feather';
import { useDropzone } from 'react-dropzone';
import mammoth from 'mammoth';
import moment from 'moment';

const HelpChatPromptMaster = () => {

  const [AllData, setAllData] = useState([]);

  // Audit Log State
  const [auditModal, setAuditModal] = useState(false);
  const [auditLogs, setAuditLogs] = useState([]);
  const [currentAuditItem, setCurrentAuditItem] = useState(null);

  const [loading, setLoading] = useState(false);

  const callApi = async (endpoint: string, data: any) => {
    const key = await keyPromise;
    const EncParams = await AesEncrypt(key, data);
    const response = await api.fetch(`api/help-chat-prompt/${endpoint}`, { method: 'POST', body: JSON.stringify({ EncParams }), headers: { 'Content-Type': 'application/json' } });
    return await response.json();
  };


  const MySwal = withReactContent(Swal);
  const UserId = localStorage.id;
  const UserName = localStorage.UserName;

  const fetchData = () => {
    callApi("get", { params: localStorage.id }).then((response) => {
      const data = response.data || response;
      if (Array.isArray(data)) {
        const systemKeys = ['_id', 'screen_name', 'status', 'created', 'Created_at', 'modified', 'field_name', 'prompt_template'];

        const mappedData = data.map(item => {
          let extractedFields = [];

          // Extract dynamic fields from the root level of the document
          Object.keys(item).forEach(key => {
            if (!systemKeys.includes(key) && typeof item[key] === 'string') {
              extractedFields.push({ field_name: key, prompt_template: item[key] });
            }
          });

          // Handle legacy data just in case
          if (extractedFields.length === 0) {
            if (item.fields && Array.isArray(item.fields)) {
              extractedFields = item.fields;
            } else if (item.field_name) {
              extractedFields = [{ field_name: item.field_name, prompt_template: item.prompt_template }];
            }
          }

          return {
            ...item,
            fields: extractedFields
          };
        });

        setAllData(mappedData);
      } else {
        setAllData([]);
      }
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleAuditModal = () => {
    setAuditModal(!auditModal);
    if (auditModal) {
      setAuditLogs([]);
      setCurrentAuditItem(null);
    }
  };

  const openAuditLog = (item) => {
    if (!item._id) return;
    setCurrentAuditItem(item);
    callApi("audit-log", { id: item._id }).then((res) => {
      if (Array.isArray(res.payload)) {
        setAuditLogs(res.data || res);
      }
      setAuditModal(true);
    });
  };

  const handleDeleteDocument = async (item, index) => {
    if (!item._id) {
      const newData = [...AllData];
      newData.splice(index, 1);
      setAllData(newData);
      return;
    }

    const dataToInsert = {
      id: item._id,
      screen_name: item.screen_name,
      Username: UserName,
      Userid: UserId,
      ParentUserId: localStorage.ParentUserId
    };

    MySwal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to remove this entire prompt document?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-secondary ms-1",
      },
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await callApi("delete", dataToInsert).then((response) => {
          if (response.message === 'Deleted Successfully') {
            Swal.fire({ icon: 'success', title: 'Deleted!', text: 'Prompt deleted successfully.', customClass: { confirmButton: 'btn btn-success' } });
            fetchData();
          }
        });
      };
    })
  };

  const handleDocumentChange = (index, field, value) => {
    const newData = [...AllData];
    newData[index][field] = value;
    newData[index].isDirty = true;
    setAllData(newData);
  };

  const handleFieldChange = (docIndex, fieldIndex, key, value) => {
    const newData = [...AllData];
    newData[docIndex].fields[fieldIndex][key] = value;
    newData[docIndex].isDirty = true;
    setAllData(newData);
  };

  const addFieldToDocument = (docIndex) => {
    const newData = [...AllData];
    newData[docIndex].fields.push({ field_name: '', prompt_template: '' });
    newData[docIndex].isDirty = true;
    setAllData(newData);
  };

  const removeFieldFromDocument = (docIndex, fieldIndex) => {
    const newData = [...AllData];
    newData[docIndex].fields.splice(fieldIndex, 1);
    newData[docIndex].isDirty = true;
    setAllData(newData);
  };

  const addNewGroup = () => {
    setAllData([{ screen_name: '', fields: [{ field_name: '', prompt_template: '' }], isNew: true, isDirty: true }, ...AllData]);
  };

  const handleSaveOrUpdate = (item, index) => {
    if (!item.screen_name) {
      MySwal.fire({ icon: 'error', title: 'Error', text: 'Master Screen Name is required.' });
      return;
    }

    const hasEmptyFields = item.fields.some(f => !f.field_name);
    if (hasEmptyFields) {
      MySwal.fire({ icon: 'error', title: 'Error', text: 'All sub-fields must have a Field Name.' });
      return;
    }

    if (item.isNew) {
      const dataPayload = {
        screen_name: item.screen_name,
        fields: item.fields,
        Username: UserName,
        Userid: UserId,
        ParentUserId: localStorage.ParentUserId
      };
      callApi("add", dataPayload).then((res) => {
        if (res.message) {
          Swal.fire({ icon: 'success', title: 'Saved!', text: 'New prompt created.' });
          fetchData();
        }
      });
    } else {
      const updatePayload = {
        id: item._id,
        params: {
          screen_name: item.screen_name,
          fields: item.fields
        },
        Username: UserName,
        Userid: UserId,
        ParentUserId: localStorage.ParentUserId
      };
      callApi("update", updatePayload).then((res) => {
        if (res.message) {
          Swal.fire({ icon: 'success', title: 'Updated!', text: 'Prompt updated successfully.' });
          fetchData();
        }
      });
    }
  };

  const handleSaveAll = () => {
    const newItems = AllData.filter(item => item.isNew);
    if (newItems.length === 0) return;

    if (newItems.some(item => !item.screen_name || item.fields.some(f => !f.field_name))) {
      MySwal.fire({ icon: 'error', title: 'Error', text: 'All new prompts must have a Master Screen Name and Field Names.' });
      return;
    }

    const dataPayload = {
      prompts: newItems,
      Username: UserName,
      Userid: UserId,
      ParentUserId: localStorage.ParentUserId
    };

    callApi("bulk-add", dataPayload).then((response) => {
      if (response.message) {
        Swal.fire({ icon: 'success', title: 'Added!', text: 'All prompts saved successfully.', customClass: { confirmButton: 'btn btn-success' } });
        fetchData();
      }
    });
  };

  const stripHtml = (html) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Docx File Parsing using Mammoth to HTML
  const onDrop = useCallback((acceptedFiles) => {
    setLoading(true);
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const arrayBuffer = e.target.result;
        try {
          const result = await mammoth.convertToHtml({ arrayBuffer });
          const html = result.value;

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          let parsedFields = [];
          let currentField = null;

          Array.from(doc.body.children).forEach(node => {
            if (node.tagName.toLowerCase() === 'h2' || node.tagName.toLowerCase() === 'h3') {
              if (currentField) {
                parsedFields.push(currentField);
              }
              currentField = {
                field_name: node.textContent.trim(),
                prompt_template: ''
              };
            } else {
              if (currentField) {
                let text = node.textContent.trim();
                if (node.tagName.toLowerCase() === 'ul' || node.tagName.toLowerCase() === 'ol') {
                  text = Array.from(node.children).map(li => `• ${li.textContent.trim()}`).join('\n');
                }
                if (text) {
                  currentField.prompt_template += (currentField.prompt_template ? '\n\n' : '') + text;
                }
              }
            }
          });

          if (currentField) {
            parsedFields.push(currentField);
          }

          if (parsedFields.length === 0) {
            // Fallback if no headings found
            parsedFields.push({
              field_name: "Main",
              prompt_template: stripHtml(html).trim()
            });
          }

          const newDocumentItem = {
            screen_name: file.name.replace(/\.[^/.]+$/, ""),
            fields: parsedFields,
            isNew: true,
            isDirty: true
          };

          setAllData(prev => [newDocumentItem, ...prev]);
          MySwal.fire({
            icon: 'success',
            title: 'Document Parsed',
            text: `Successfully extracted ${parsedFields.length} fields from ${file.name}. Please review and click Save All New Prompts.`,
          });
          setLoading(false);

        } catch (error) {
          console.error("Error parsing docx", error);
          setLoading(false);
          MySwal.fire({ icon: 'error', title: 'Parsing Error', text: 'Failed to read the Word Document.' });
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'] }
  });

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center mb-2 bg-white p-2 rounded shadow-sm">
        <div>
          <h4 className="text-primary fw-bolder mb-0">Chat Screen Prompt Master</h4>
          <p className="text-muted mb-0" style={{ fontSize: '13px' }}>Manage global chat screen prompts and configurations</p>
        </div>
        <div className="d-flex gap-1">
          {AllData.some(item => item.isNew) && (
            <Button color="success" onClick={handleSaveAll}>
              <UploadCloud size={16} className="me-50" /> Save All Uploads
            </Button>
          )}
          <Button color="primary" onClick={addNewGroup}>
            <Plus size={16} className="me-50" /> Add New Document
          </Button>
        </div>
      </div>

      <div {...getRootProps()} className={`dropzone border border-dashed rounded p-2 mb-3 text-center cursor-pointer ${isDragActive ? 'bg-light-primary border-primary' : 'bg-white shadow-sm'}`}>
        <input {...getInputProps()} />
        {loading ? (
          <Spinner color="primary" />
        ) : (
          <>
            <UploadCloud size={24} className="text-primary mb-50" />
            <h6 className="mb-0">{isDragActive ? "Drop .docx file here..." : "Drag & drop a .docx file here to auto-extract into fields"}</h6>
          </>
        )}
      </div>

      <div className="prompt-list">
        {AllData && AllData.length > 0 ? (
          AllData.map((item, docIndex) => (
            <Card key={item._id || docIndex} className="shadow-sm mb-3 border-primary" style={{ borderRadius: '8px', overflow: 'hidden' }}>
              <CardHeader className="bg-light-primary py-1 px-2 d-flex justify-content-between align-items-center">
                <div className="w-75">
                  <Label className="text-uppercase text-primary fw-bolder mb-25" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Master Screen Name (Document Name)</Label>
                  <Input
                    type="text"
                    value={item.screen_name || ''}
                    onChange={(e) => handleDocumentChange(docIndex, 'screen_name', e.target.value)}
                    placeholder="e.g. ReviewGenX_Platform"
                    className="border-0 shadow-sm"
                    style={{ fontSize: '16px', fontWeight: 'bold' }}
                  />
                </div>
                <div>
                  <Trash2 size={18} className="text-danger cursor-pointer hover-danger" onClick={() => handleDeleteDocument(item, docIndex)} />
                </div>
              </CardHeader>
              <CardBody className="p-2 bg-light">
                {item.fields && item.fields.map((field, fieldIndex) => (
                  <Card key={fieldIndex} className="mb-2 shadow-none border">
                    <CardBody className="p-1">
                      <div className="d-flex justify-content-between align-items-center mb-50">
                        <div className="w-50">
                          <Label className="text-uppercase text-muted fw-bolder mb-25" style={{ fontSize: '10px' }}>Field Name (Heading)</Label>
                          <Input
                            type="text"
                            bsSize="sm"
                            value={field.field_name || ''}
                            onChange={(e) => handleFieldChange(docIndex, fieldIndex, 'field_name', e.target.value)}
                            placeholder="Enter Field Name"
                            className="bg-white"
                          />
                        </div>
                        <Button color="flat-danger" size="sm" className="btn-icon p-50 rounded-circle" onClick={() => removeFieldFromDocument(docIndex, fieldIndex)}>
                          <Trash2 size={14} />
                        </Button>
                      </div>

                      <div className="border rounded p-1 mb-0 mt-1 bg-white">
                        <div className="d-flex justify-content-between align-items-center mb-1 text-muted" style={{ fontSize: '11px' }}>
                          <div className="d-flex align-items-center text-primary font-monospace">
                            <Code size={12} className="me-50" /> CHAT PROMPT TEMPLATE
                          </div>
                          <div className="d-flex gap-1">
                            <span className="cursor-pointer hover-primary" onClick={() => copyToClipboard(field.prompt_template)}><Copy size={12} className="me-25" /> Copy</span>
                            <span className="cursor-pointer hover-primary"><Maximize size={12} className="me-25" /> Fullscreen</span>
                          </div>
                        </div>
                        <Input
                          type="textarea"
                          rows="4"
                          className="border-0 p-0 shadow-none bg-transparent"
                          style={{ resize: 'none' }}
                          value={field.prompt_template || ''}
                          onChange={(e) => handleFieldChange(docIndex, fieldIndex, 'prompt_template', e.target.value)}
                          placeholder="Type your prompt instructions here..."
                        />
                      </div>
                    </CardBody>
                  </Card>
                ))}

                <div className="mt-1">
                  <Button color="outline-primary" size="sm" onClick={() => addFieldToDocument(docIndex)} className="border-dashed w-100 py-1">
                    <Plus size={14} className="me-50" /> Add New Field to this Document
                  </Button>
                </div>

                <div className="d-flex justify-content-end gap-1 mt-2 pt-1 border-top">
                  <Button color="outline-secondary" size="sm" onClick={() => openAuditLog(item)} disabled={item.isNew}>
                    <Activity size={14} className="me-50" /> Audit Log
                  </Button>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleSaveOrUpdate(item, docIndex)}
                    disabled={!item.isDirty && !item.isNew}
                  >
                    {item.isNew ? 'Save Document' : 'Update Document'}
                  </Button>
                </div>
              </CardBody>
            </Card>
          ))
        ) : (
          <Card className="text-center shadow-sm">
            <CardBody className="py-5">
              <FileText size={48} className="text-muted mb-1" style={{ opacity: 0.5 }} />
              <h4>No Prompts Found</h4>
              <p className="text-muted">Click the button above to add or upload new documents.</p>
            </CardBody>
          </Card>
        )}
      </div>

      {/* Audit Log Modal */}
      <Modal isOpen={auditModal} toggle={toggleAuditModal} size="xl" className="modal-dialog-centered">
        <ModalHeader toggle={toggleAuditModal} className="bg-light">
          Audit Log for <span className="text-primary">{currentAuditItem?.screen_name}</span>
        </ModalHeader>
        <ModalBody className="p-0">
          <Table responsive hover className="m-0">
            <thead className="table-light">
              <tr>
                <th>Action</th>
                <th>User Name</th>
                <th>Changes</th>
                <th>Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {auditLogs.length > 0 ? auditLogs.map((log, idx) => (
                <tr key={idx}>
                  <td>
                    <Badge color={log.Action === 'ADD' ? 'light-success' : log.Action === 'EDIT' ? 'light-warning' : 'light-danger'} className="rounded-pill px-1">
                      {log.Action}
                    </Badge>
                  </td>
                  <td>{log.UserName || log.Userid || 'System'}</td>
                  <td>
                    {Array.isArray(log.JsonData) ? (
                      <ul className="mb-0 ps-1 list-unstyled" style={{ fontSize: '12px' }}>
                        {log.JsonData.map((j, i) => (
                          <li key={i} className="mb-50">
                            <strong>{j.field}:</strong>
                            {log.Action === 'EDIT' ? (
                              <>
                                <div className="text-danger bg-light-danger px-50 rounded mt-25"><del>{j.before}</del></div>
                                <div className="text-success bg-light-success px-50 rounded mt-25">{j.after}</div>
                              </>
                            ) : (
                              <span className="text-secondary ms-50">{j.value}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <span className="text-muted" style={{ fontSize: '12px' }}>{String(log.JsonData)}</span>
                    )}
                  </td>
                  <td>{moment(log.Modified).format('DD MMM YYYY, hh:mm A')}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="4" className="text-center py-3 text-muted">No audit logs found for this document.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

    </Fragment>
  );
};

export default HelpChatPromptMaster;
